import PropTypes from "prop-types"
import React, { useCallback, useEffect, useMemo } from "react"
import { useInfiniteQuery } from "react-query"
import DealsList from "src/main/DockwaPlusDeals/Marketing/DealsList"
import { renderStatus } from "src/main/DockwaPlusDeals/Marketing/shared_methods"

import {
  queryDockageDeals,
  queryFuelDeals,
} from "src/api/DockwaPlusDeals/Marketing"

const AllDeals = ({ deals, hasActiveDockwaPlusSubscription, variant }) => {
  const queryDeals = ({ page }) => {
    if (variant === "fuel") {
      return queryFuelDeals({ page })
    } else if (variant === "reservation") {
      return queryDockageDeals({ page })
    }
  }

  const {
    isFetching,
    isError,
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    error,
  } = useInfiniteQuery({
    queryKey: ["allDockwaPlusDeals", variant],
    queryFn: ({ pageParam = 1 }) => queryDeals({ page: pageParam }),
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.length) {
        return pages.length + 1
      }
    },
    initialData: deals,
  })

  const handleScroll = useCallback(() => {
    const triggerAt = 200
    const scrolledToTriggerPoint =
      window.scrollY + window.innerHeight >=
      document.documentElement.scrollHeight - triggerAt

    if (scrolledToTriggerPoint) {
      if (hasNextPage && !isFetchingNextPage) fetchNextPage()
    }
  }, [hasNextPage, fetchNextPage, isFetchingNextPage])

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [handleScroll])

  const allDeals = useMemo(() => data?.pages?.flat?.() || data, [data])

  return isLoading || isError ? (
    renderStatus({ isLoading, isError, error })
  ) : (
    <DealsList
      deals={allDeals}
      hasActiveDockwaPlusSubscription={hasActiveDockwaPlusSubscription}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      variant={variant}
    />
  )
}

AllDeals.propTypes = {
  deals: PropTypes.array.isRequired,
  hasActiveDockwaPlusSubscription: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(["reservation", "fuel"]),
}

export default AllDeals
